import React from "react";
import "../Style/style.css";
import img1 from "../Assests/img1.jpg";
import img2 from "../Assests/img2.jpg";
import img3 from "../Assests/img3.jpg";
import NavBar from "../../components/Navbar";
import Footer from "../../components/Footer";

const ProfessionalsCategory = () => {

const callouts = [
  {
    name: 'Architecture',
    description: '"Discover awe-inspiring architectural wonders that redefine innovation and elegance in our curated collection on the BoQ website."',
    imageSrc: img1,
    imageAlt: 'Desk with leather desk pad, walnut desk organizer, wireless keyboard and mouse, and porcelain mug.',
    href: '/archiList',
  },
  {
    name: 'Quantity Surveyors',
    description: "Empowering efficient construction with precise cost management - Your trusted Quantity Surveyors.",
    imageSrc: img3,
    imageAlt: 'Wood table with porcelain mug, leather journal, brass pen, leather key ring, and a houseplant.',
    href: '/qsList',
  },
  {
    name: 'Civil Engineers',
    description: '"Building the worlds foundation, one blueprint at a time - Trust our skilled civil engineers to construct your dreams with precision and innovation."',
    imageSrc: img2,
    imageAlt: 'Collection of four insulated travel bottles on wooden shelf.',
    href: 'ceList',
  },
]

  return (
    <div>
      <NavBar />
    <div className="bg-gray-100">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl py-16 sm:py-24 lg:max-w-none lg:py-32">
          <h2 className="text-2xl font-bold text-gray-900">Collections</h2>

          <div className="mt-6 space-y-12 lg:grid lg:grid-cols-3 lg:gap-x-6 lg:space-y-0">
            {callouts.map((callout) => (
              <div key={callout.name} className="group relative">
                <div className="relative h-80 w-full overflow-hidden rounded-lg bg-white sm:aspect-h-1 sm:aspect-w-2 lg:aspect-h-1 lg:aspect-w-1 group-hover:opacity-75 sm:h-64">
                  <img
                    src={callout.imageSrc}
                    alt={callout.imageAlt}
                    className="h-full w-full object-cover object-center"
                  />
                </div>
                <h3 className="mt-6 text-sm text-gray-500">
                  <a href={callout.href}>
                    <span className="absolute inset-0" />
                    {callout.name}
                  </a>
                </h3>
                <p className="text-base font-semibold text-gray-900">{callout.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    <Footer />
    </div>

  )
}


export default ProfessionalsCategory;
